module.exports = __webpack_public_path__ + "img/model_12.45bdbca1.jpg";